import { Stack } from "@mui/material";

import Header from "../components/Header";
import Lab from "../components/Lab";

const LabPage = () => {
  return (
    <Stack>
      <Header />
      <Lab />
    </Stack>
  );
};

export default LabPage;
